import React from "react";
import { CouponType, CouponTypeCopy } from "types";
import { ListFilter } from "@/components/Dashboard/Filters/ListFilter";
import { FilterButton, FilterButtonProps } from "@/components/PurchasesMenu/PurchaseFilterButton";
import { SelectionState } from "@/hooks/useSelection";

interface CouponTypeFilterSelectorProps {
    value: SelectionState;
    onChange: (value: SelectionState) => void;
}

type FilterButtons = Array<{ id: CouponType; name: string }>;
const buttons: FilterButtons = [
    { id: CouponType.DISCOUNT, name: CouponTypeCopy.discount },
    { id: CouponType.VOUCHER, name: CouponTypeCopy.voucher },
    { id: CouponType.BXGY, name: CouponTypeCopy.bxgy },
    { id: CouponType.UNLOCK, name: CouponTypeCopy.unlock },
];

const CouponFilterButton = ({ label, value, onClick }: FilterButtonProps) => {
    return (
        <div className="w-44">
            <FilterButton label={label} value={value} onClick={onClick} />
        </div>
    );
};

export const CouponTypeFilterSelector = ({ value, onChange }: CouponTypeFilterSelectorProps) => {
    return (
        <div>
            <ListFilter
                disableUnassignedOnSelection
                label={value.all || value.selected.length === 0 ? "All Coupon Types" : "Coupon Types"}
                target={CouponFilterButton}
                fetch={() => ({ data: buttons })}
                value={value}
                show={{ search: false, sortOptionsBy: null }}
                onChange={onChange}
            />
        </div>
    );
};
